import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import FormHandler from '../FormHandler';
import { Stack } from '@mui/material';
import PasswordField from '../PasswordField';
import { AlertType, TowerAlert } from '../../../common/Alerts';
import isEmpty from 'lodash/isEmpty';
import useFocus from '../hooks/useFocus';
import { Email } from '../styledComponents';
import Button from '@mui/material/Button';
import { useUsername } from '../../slices/hooks/useUsersSlice';
import { usePasswordValidation } from './usePasswordValidation';
import { PasswordPolicy } from '../../slices/types';
import Policy from './Policy';

// @ts-ignore
const passwordPolicy: PasswordPolicy = window.PASSWORD_POLICY || {
    minLength: 8,
    requiresLetter: false,
    requiresNumber: false,
    requiresSymbol: false,
    requiresUppercase: false,
};

interface Props {
    show: boolean;
    code: string;
    setAlerts: (a: TowerAlert[]) => void;
    isLoading: boolean;
    resetPassword: (p: string, c: string) => void;
    onReset: () => void;
}
const ResetForm = ({ show, code, setAlerts, isLoading, resetPassword, onReset }: Props) => {
    const { username: email } = useUsername();
    const [password1, setPassword1] = useState<string>('');
    const [password2, setPassword2] = useState<string>('');
    const focusInputRef = useFocus();
    const passwordValidation = usePasswordValidation(password1, password2, passwordPolicy);
    const isValidPassword = passwordValidation.isValid;

    if (!show) {
        return <></>;
    }

    const handleFormSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setAlerts([]);
        if (!isValidPassword) {
            setAlerts([
                {
                    type: AlertType.error,
                    message: 'Your password does not meet our requirements.',
                },
            ]);
        }
        if (isValidPassword) {
            resetPassword(password1, code);
        }
    };

    return (
        <>
            <Typography variant="h5" mb="25px" gutterBottom style={{ textAlign: 'center' }}>
                Reset your password
                <Email mt="10px">{email}</Email>
                <Button onClick={() => onReset()}>Not you?</Button>
            </Typography>
            <FormHandler
                onSubmit={handleFormSubmit}
                buttonText="Reset Password"
                isDisabled={isLoading}
                isLoading={isLoading}
            >
                <Stack
                    direction="column"
                    spacing={2}
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <PasswordField
                        key={'password-visible'}
                        value={password1}
                        placeholder="Required"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            setPassword1(e.target.value)
                        }
                        inputRef={focusInputRef}
                    />
                    <PasswordField
                        key={'password-visible2'}
                        label="Confirm Password"
                        value={password2}
                        placeholder="Required"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            setPassword2(e.target.value)
                        }
                        styles={{ marginBottom: '20px' }}
                    />
                </Stack>
            </FormHandler>
            <Policy {...passwordValidation} passwordPolicy={passwordPolicy} />
        </>
    );
};
export default ResetForm;
